import React, { Component } from 'react';

import i18n from 'i18n-react';
import PropTypes from 'prop-types';

import { storageKeys } from 'settings';

import {
  APIHandler,
  DataHandler,
  Diploma,
  StorageHandler,
  TrainingGrid,
  ContentHeader,
  Progress,
} from 'C4';

const getTotalPages = (res) => {
  let totalPages = 0;
  if (res && res.data && res.data[0]) {
    const { chapters } = res.data[0];
    chapters.forEach((chapter) => {
      totalPages += chapter.total_pages;
    });
  }
  return totalPages;
};

// Makes sure progress is returned in percentage value
const calculateProgress = (progress, pages) => Math.floor((progress / pages) * 100);

const getTotalProgress = (res) => {
  let totalProgress = 0;

  if (res && res.data && res.data[0]) {
    const { chapters } = res.data[0];
    chapters.forEach((chapter) => {
      totalProgress += chapter.progress;
    });
  }

  return totalProgress;
};

export default class TrainingView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      totalProgressValue: 0,
      diploma: 0,
      firstName: 'Firstname',
      lastName: 'Lastname',
    };
  }

  componentDidMount() {
    this.mounted = true;
    this.getUserInfo();
  }

  componentDidUpdate() {
    const { diploma, totalProgressValue } = this.state;
    if (totalProgressValue >= 100 && diploma !== 100) {
      this.setState({ diploma: 100 });
    }

    if (diploma >= 100) {
      const d = new Date(Date.now());
      const leading = val => (`0${val}`).slice(-2);
      StorageHandler.load(storageKeys.user)
        .then((user) => {
          if (user.training_graduated === null) {
            const obj = user;
            const date = `${d.getFullYear()}-${leading(d.getMonth() + 1)}-${leading(d.getDate())}`;
            DataHandler.matchAppId()
              .then((appId) => {
                APIHandler.updateUser(appId, obj.email, [
                  { param: 'sales_companion_registered', val: date },
                  { param: 'training_started', val: date },
                  { param: 'training_graduated', val: date },
                ]).then((res) => {
                  if (res && obj) {
                    obj.sales_companion_registered = date;
                    obj.training_started = date;
                    obj.training_graduated = date;
                    StorageHandler.save(storageKeys.user, obj);
                  }
                });
              });
          }
        });
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  getUserInfo() {
    StorageHandler.load(storageKeys.user).then((res) => {
      if (res) {
        const { email } = res;
        DataHandler.matchAppId().then((appId) => {
         APIHandler.getUserProgress(appId, email)
            .then((userProgress) => {
              const totalProgress = getTotalProgress(userProgress);
              const totalPages = getTotalPages(userProgress);
              const percentage = calculateProgress(totalProgress, totalPages);
              this.setState({ totalProgressValue: (percentage >= 100 ? 100 : percentage) });

              if (percentage >= 100) {
                this.setState({ diploma: 100 });
              } else {
                this.setState({ diploma: 0 });
              }
            });
          StorageHandler.load(storageKeys.user).then((user) => {
            const { first_name: firstName, last_name: lastName } = user;
            this.setState({ firstName, lastName, appId });
          });
        });
      } else {
        this.setState({ totalProgressValue: 0 });
      }
    });
  }

  render() {
    const {
      diploma,
      firstName,
      lastName,
      totalProgressValue,
      appId,
    } = this.state;

    return (
      <div className="contentContainer trainingView">
        <ContentHeader
          header={i18n.translate('contentHeaders.train')}
          subtitle={i18n.translate('pageDescriptions.train')}
          line={false}
        >
          <div className="container__Progress">
            <div className="container__progressBar">
              <h6 className="progressText">{`${totalProgressValue}% Complete`}</h6>
              <Progress id="progress" value={totalProgressValue} />
            </div>      
            <style>{'\
            #openWidget { display: block; } '}
            </style>
          </div>
        </ContentHeader>
        <TrainingGrid />
      </div>
    );
  }
}

Diploma.propTypes = {
  appId: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
};

Diploma.defaultProps = {
  firstName: '',
  lastName: '',
};
